/**
 * Dependencies
 */

import { styled } from '@material-ui/styles';

/**
 * Define style
 */

const HeaderH3 = styled('h3')({
  color: '#333',
  fontWeight: '800',
  paddingBottom: '20px',
});

/**
 * Export style
 */

export default HeaderH3;
